
<template>
    <div v-if="$wait.is('loading_sections')" class="loading">
        <Spinner :height="40" :width="40"/>
    </div>
    <div v-else>
        <div class="grid grid--sectors">
            <div class="col-sm-4 col-6" v-for="item in sectors">
                <SectorCard :resource="item"/>
            </div>
        </div>
    </div>
</template>
<script>
import API from "@api";
import SectorCard from '@components/Sector/Grid/Card';
import Spinner from '@components/Spinner.vue';

export default {
    name: 'SectorGrid',
    data: () => ({
        isLoading: {
            type: Boolean,
            default: true,
        },
        sectors: {
            type: Array,
            default: () => [],
        }
    }),
    components: {
        Spinner,
        SectorCard,
    },
    methods: {
        async getData() {
            this.$wait.start('loading_sections');
            try {
                const data = await API.getSectors({
                    top_level: true,
                    only_public: true,
                    include_counts: false,
                    hierarchical: false,
                    order_by: "name",
                    order: "ASC",
                });

                if(!data){
                    throw new Error("API Error occurred");
                }

                this.sectors = data;

                return false;
            } catch(error){
                console.warn(`[SectorGrid] ${error.message}`);
            } finally {
                this.$wait.end('loading_sections');
            }

            return false;
        }
    },
    created() {
        this.getData();
    },
}
</script>

<style lang="scss" scoped>
    .grid--sectors {
        margin-left: -1rem;
        margin-right: -1rem;

        [class*="col-"] {
            padding: 1rem;
        }
    }
</style>
